import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: "#f5f5f9",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 350,
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #dadde9",
  },
}))(Tooltip);

export const Tooltips = ({
  title,
  description,
  children,
  link,
  linka,
  linkb,
}) => (
  <HtmlTooltip
    interactive
    placement="top"
    title={
      <>
        <Typography color="inherit">{title}</Typography>
        {description}
        <Grid row>
          <Grid item xs={12}>
            <a target="_blank" rel="noopener noreferrer" href={link}>
              {link}
            </a>
          </Grid>
          <Grid item xs={12}>
            <a target="_blank" rel="noopener noreferrer" href={linka}>
              {linka}
            </a>
          </Grid>
          <Grid item xs={12}>
            <a target="_blank" rel="noopener noreferrer" href={linkb}>
              {linkb}
            </a>
          </Grid>
        </Grid>
      </>
    }
  >
    {children}
  </HtmlTooltip>
);

Tooltips.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  description: PropTypes.string,
  link: PropTypes.string,
  linka: PropTypes.string,
  linkb: PropTypes.string,
};

Tooltips.defaultProps = {
  description: "",
  link: "",
  linka: "",
  linkb: "",
};
